export default __webpack_public_path__ + "3c8f608e5858004e49dea9b75f44bb33.png";